import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import AddImage from '../../reusable/images/add-image/add-image.component';
import Spinner from '../../reusable/spinner/spinner.component';

import { ToastContext } from '../../../contexts/toast.context';

import Client from '../../../tools/client';

import {
  AddCategoryButton,
  AddCategoryContainer,
  AddCategoryInput,
  AddCategoryTextarea,
  AddCategorySubtitle,
  NewCategoryContainer
} from './add-category.styles';

const client = new Client();

const AddCategory = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [categoryTypes, setCategoryTypes] = useState([]);
  const [image, setImage] = useState('');
  const [cropData, setCropData] = useState(null);

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [categoryTypeId, setCategoryTypeId] = useState('');

  const { errorToast, successToast } = useContext(ToastContext);

  useEffect(() => {
    getCategoryTypes();
  }, []);

  const getCategoryTypes = async () => {
    setLoading(true);
    const res = await client.getAllCategoryTypes();

    const options = res.map((ct) => ({ value: ct.id, label: ct.name }));
    setCategoryTypes(options);
    setLoading(false);
  };

  const addCategory = async () => {
    if (!name || !description || !categoryTypeId?.value) {
      errorToast('Please fill out all fields.');
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('categoryTypeId', categoryTypeId.value);
    formData.append('motherProductId', null);
    formData.append('fatherProductId', null);

    if (image) {
      formData.append('files', image);
      formData.append('crop', JSON.stringify(cropData));
    }

    const res = await client.createCategory(formData);

    if (res.status === 400) {
      setLoading(false);
      errorToast(res.message);
      return;
    }

    successToast('Category Created');
    navigate(`/categories/${res.id}`);
  };

  return (
    <AddCategoryContainer>
      {loading ? (
        <Spinner />
      ) : (
        <NewCategoryContainer>
          <AddImage image={image} setImage={setImage} setCropData={setCropData} />

          <AddCategoryInput
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Name"
          />
          <AddCategoryTextarea
            name="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Description"
          />
          <AddCategorySubtitle>Category Type:</AddCategorySubtitle>
          <Select
            options={categoryTypes}
            value={categoryTypeId}
            onChange={setCategoryTypeId}
            placeholder="-- select an option --"
          />
          <AddCategoryButton onClick={addCategory}>Add Category</AddCategoryButton>
        </NewCategoryContainer>
      )}
    </AddCategoryContainer>
  );
};

export default AddCategory;